export const REDUX_SAVE_USER_SETTINGS = 'REDUX_SAVE_USER_SETTINGS'

export const REDUX_PROFILE_PICTURE_UPDATE = 'REDUX_PROFILE_PICTURE_UPDATE'

export const REDUX_IMPERSONATE = 'REDUX_IMPERSONATE'
export const REDUX_REVERT_TO_ORIGINAL_USER = 'REDUX_REVERT_TO_ORIGINAL_USER'

export const REDUX_SAVE_AI_CREDITS = 'REDUX_SAVE_AI_CREDITS'

export const REDUX_SET_URDD_ID = 'REDUX_SET_URDD_ID'
